// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e7749298","239":"0747efaf","453":"0dd83b12","732":"7ddf88e5"}[chunkId] + ".chunk.js";
};